import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { login } from './../utils/api'
import Cookies from 'universal-cookie'

const cookies = new Cookies()

function Login() {
  let history = useHistory()
  const [user, setUser] = useState({ email: '', password: '' })
  async function userLogin(e) {
    try {
      if (e)
        e.preventDefault();
      let response = await login(user)
      if (response) {
        cookies.set('token', '', { path: '/' })
        cookies.set('token', response.data.access_token, { path: '/' })
        localStorage.setItem('token', response.data.access_token)
        history.push('/admin')
      }
    } catch (err) {
      console.log('userLogin -> err', err)
      // console.log(err.response.data)
    }
  }

  function valueChange(event) {
    let temp = { ...user }
    temp[event.target.name] = event.target.value
    setUser(temp)
  }

  return (
    <section id="aa-myaccount">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="aa-myaccount-area">
              <div className="row">
                <div className="col-md-6">
                  <div className="aa-myaccount-login">
                    <h4>Login test </h4>
                    <form onSubmit={userLogin} className="aa-login-form">
                      <label htmlFor="">
                        Username or Email address<span>*</span>
                      </label>
                      <input type="text" value={user.email} name="email" onChange={valueChange} placeholder="Username or email" />
                      <label htmlFor="">
                        Password<span>*</span>
                      </label>
                      <input type="password" value={user.password} onChange={valueChange} name="password" placeholder="Password" />
                      <button type="submit" onClick={userLogin} className="aa-browse-btn">
                        Login
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export { Login }
